import React from "react";
import { UNSAFE_LocationContext, UNSAFE_RouteContext } from "react-router-dom";

/**
 * NavigationContextReset — lets a per-window MemoryRouter mount inside the app's
 * outer HashRouter and resolve routes correctly.
 *
 * Two contexts must be reset:
 *  1. LocationContext → null, so React Router v6 doesn't throw on a nested Router.
 *  2. RouteContext → empty matches, so the inner <Routes> resolves RELATIVE route
 *     paths (e.g. "sales") against "/" instead of the outer matched route's base.
 *
 * The tab system only resets LocationContext because its outer route is "/*"
 * (base "/"). The Webtop mounts at "/webtop" (base "/webtop"), so without the
 * RouteContext reset the inner Routes would try to match "/webtop/sales" and
 * fall through to the catch-all. Resetting matches=[] fixes it.
 */
const EMPTY_ROUTE_CONTEXT = { outlet: null, matches: [], isDataRoute: false };

const NavigationContextReset = ({ children }) => (
  <UNSAFE_RouteContext.Provider value={EMPTY_ROUTE_CONTEXT}>
    <UNSAFE_LocationContext.Provider value={null}>
      {children}
    </UNSAFE_LocationContext.Provider>
  </UNSAFE_RouteContext.Provider>
);

export default NavigationContextReset;
